import { render, staticRenderFns } from "./AddToHomeScreenBanner.vue?vue&type=template&id=bfeac948&scoped=true&"
import script from "./AddToHomeScreenBanner.vue?vue&type=script&lang=js&"
export * from "./AddToHomeScreenBanner.vue?vue&type=script&lang=js&"
import style0 from "./AddToHomeScreenBanner.vue?vue&type=style&index=0&id=bfeac948&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfeac948",
  null
  
)

export default component.exports